import { AppError } from '@/errors/appError';
import { toRaw, type Ref } from 'vue';

export function useRemoteDictionaryHelpers<T extends { id: number; name: string }>(itemsRef: Ref<T[]>) {
    const _cacheItems: Record<string | number, T> = {};

    function itemById(id: T['id']): T {
        if (_cacheItems[id]) return _cacheItems[id];

        const rawItems = toRaw(itemsRef.value); // to speedUp
        const found = rawItems.find((i) => i.id === id);
        if (!found) throw new AppError(`Item #${id} not found in dictionary`);

        _cacheItems[id] = found;
        return found;
    }

    function nameById(id: number, defaultName?: string): string {
        const item = itemById(id);

        if (!item) {
            if (!defaultName) {
                throw new AppError(`Item #${id} not found in dictionary`);
            }

            return defaultName;
        }

        return item.name;
    }

    function filterByName(searchString: string) {
        searchString = searchString.toLowerCase();
        const rawItems = toRaw(itemsRef.value); // to speedUp

        return rawItems.filter((i) => {
            return i.name.toLowerCase().indexOf(searchString) > -1;
        });
    }

    return {
        itemById,
        nameById,
        filterByName,
    };
}
